import { Reveal } from "./Reveal";
import { Quote } from "lucide-react";

const OWNERS = [
  {
    id: "testimonial-owner-card-1",
    name: "Sarah Mitchell",
    meta: "Multi-Unit Owner — 3 Locations, Texas",
    quote: "The membership model changed everything. Predictable monthly revenue let me scale from one location to three in under four years.",
    image: "owner1",
  },
  {
    id: "testimonial-owner-card-2",
    name: "Marcus & Dana Reed",
    meta: "Multi-Unit Owners — 4 Locations, Midwest",
    quote: "We came from corporate careers with zero pet industry experience. Dogtopia University and the support team made the leap feel safe.",
    image: "owner2",
  },
  {
    id: "testimonial-owner-card-3",
    name: "Elena Vasquez",
    meta: "Owner — 2 Locations, Arizona",
    quote: "Watching pet parents check the webcams at lunch and smile — that's when I knew this business sells joy, and the economics follow.",
    image: "owner3",
  },
];

export function Testimonials({ images }) {
  return (
    <section id="testimonials" className="py-20 md:py-28 bg-[#0D3B3E]" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#F7C948] mb-4">Owner Stories</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white max-w-2xl">
            Meet the owners building their legacy with Dogtopia
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {OWNERS.map((o, i) => (
            <Reveal key={o.id} delay={0.08 * i}>
              <article className="h-full bg-white rounded-3xl overflow-hidden border border-[#E4DFD3] flex flex-col" data-testid={o.id}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={images[o.image]}
                    alt={`${o.name}, Dogtopia franchise owner`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <Quote className="w-6 h-6 text-[#FF6B4A] mb-4" />
                  <p className="text-[#142526] leading-relaxed flex-1">"{o.quote}"</p>
                  <div className="mt-6">
                    <div className="font-display font-bold text-[#0D3B3E]">{o.name}</div>
                    <div className="text-xs uppercase tracking-widest text-[#5C6B6C] mt-1">{o.meta}</div>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
